"use client"

import Script from "next/script"

import { buildBootstrapScript } from "@workspace/analytics"

import { useAnalytics } from "./analytics-provider"

/**
 * Loads the tenant's Google tag through the ordered inline bootstrap from
 * `@workspace/analytics` (consent defaults → saved choice → loader). Hand-rolled
 * rather than `@next/third-parties`, whose `GoogleTagManager` can't guarantee
 * the Consent Mode defaults land before the container. No `<noscript>` iframe:
 * it would bypass consent entirely.
 */
export function GoogleTag() {
  const { tag } = useAnalytics()
  if (!tag) return null
  return (
    <Script
      id="google-tag-bootstrap"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{ __html: buildBootstrapScript(tag) }}
    />
  )
}
